import React, { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import TopCard from "../../components/UserSideComponents/TopCard";

const BlogDetail = () => {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/blogs/get`);
      const data = res.data || [];
      setBlogs(data);

      const cats = Array.from(
        new Set(data.map((b) => b.category).filter(Boolean))
      );
      setCategories(cats);

      setSelectedBlog(data[0] || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 120,
    });
  }, []);

  const handleCategoryClick = (cat) => {
    setSelectedCategory(cat);
    if (cat === "All") {
      setSelectedBlog(blogs[0] || null);
      return;
    }
    const found = blogs.find((b) => b.category === cat);
    setSelectedBlog(found || null);
  };

  const displayedBlog = selectedBlog;

  return (
    <div className="bg-[#FFF9F7] ">
      <div>
        <TopCard />
      </div>

      <div className=" mx-auto px-4 sm:px-8 md:px-10 lg:px-12  grid grid-cols-1 lg:grid-cols-4 py-12 rounded-xl gap-10 pt-12">
        {/* Main Content */}
        <div className="lg:col-span-3 bg-white">
          {loading ? (
            <div className="p-10">
              <div className="animate-pulse space-y-6">
                <div className="w-full h-[420px] bg-gray-200 rounded-md" />

                <div className="space-y-4">
                  <div className="w-1/3 h-4 bg-gray-200 rounded" />
                  <div className="w-2/3 h-10 bg-gray-200 rounded" />
                  <div className="w-full h-3 bg-gray-200 rounded" />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="w-full h-[260px] bg-gray-200 rounded" />
                    <div className="w-full h-[260px] bg-gray-200 rounded" />
                  </div>

                  <div className="h-4 bg-gray-200 rounded" />
                  <div className="h-4 bg-gray-200 rounded w-4/5" />
                </div>
              </div>
            </div>
          ) : displayedBlog ? (
            <>
              {displayedBlog.image && (
                <img
                  src={displayedBlog.image}
                  alt={displayedBlog.category}
                  className="w-full h-[420px] object-cover rounded-md "
                />
              )}

              <div className="p-10">
                <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
                  {new Date(displayedBlog.createdAt).toLocaleDateString()} /{" "}
                  {displayedBlog.category}
                </p>

                <h1 className="font-serif text-3xl md:text-4xl mb-6 text-gray-900 leading-snug">
                  {displayedBlog.category}
                </h1>

                <p className="text-gray-600 leading-7 mb-6">
                  {displayedBlog.description}
                </p>

                {/* Image Grid (if multiple images are present later) */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  {displayedBlog.image && (
                    <img
                      src={displayedBlog.image}
                      alt="related"
                      className="w-full h-[260px] object-cover"
                    />
                  )}
                  {displayedBlog.image && (
                    <img
                      src={displayedBlog.image}
                      alt="related"
                      className="w-full h-[260px] object-cover"
                    />
                  )}
                </div>

                <p className="text-gray-600 leading-7">
                  More details about the blog will appear here.
                </p>
              </div>
            </>
          ) : (
            <div className="p-10">No blogs found for this category.</div>
          )}
        </div>

        {/* Sidebar */}
        <aside className="bg-[#F3E9DF] p-8 h-fit rounded-md">
          <h3 className="font-serif text-xl mb-6">Categories</h3>

          {loading ? (
            <div className="space-y-6">
              <div className="w-20 h-4 bg-gray-200 rounded" />

              <div className="space-y-3">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="w-full h-3 bg-gray-200 rounded" />
                ))}
              </div>

              <div className="mt-8">
                <div className="w-32 h-5 bg-gray-200 rounded mb-3" />
                <div className="space-y-3">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-full h-3 bg-gray-200 rounded" />
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <>
              <ul className="space-y-4 text-sm">
                <li
                  className={`flex items-center gap-2 cursor-pointer ${
                    selectedCategory === "All"
                      ? "text-[#C28B61]"
                      : "text-gray-700 hover:text-[#C28B61]"
                  }`}
                  onClick={() => handleCategoryClick("All")}
                >
                  › All
                </li>
                {categories.map((cat) => (
                  <li
                    key={cat}
                    className={`flex items-center gap-2 cursor-pointer ${
                      selectedCategory === cat
                        ? "text-[#C28B61]"
                        : "text-gray-700 hover:text-[#C28B61]"
                    }`}
                    onClick={() => {
                      handleCategoryClick(cat);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    › {cat}
                  </li>
                ))}
              </ul>

              <div className="mt-8">
                <h4 className="font-serif text-lg mb-3">Recent Posts</h4>
                <ul className="space-y-3">
                  {blogs.slice(0, 5).map((b) => (
                    <li
                      key={b._id}
                      className="text-sm text-gray-700 hover:text-[#C28B61] cursor-pointer"
                      onClick={() => {
                        setSelectedBlog(b);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      {b.category} - {b.description?.slice(0, 40)}...
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </aside>
      </div>
    </div>
  );
};

export default BlogDetail;
